/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('MainController', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', '$timeout', function ($rootScope, $scope, $http, NetworkService, MainService, Notification, $timeout) {


        $scope.showEmailHint = false;
        $scope.showCredentials = false;
        $scope.lastScan = "-1"
        $scope.nextButton = false;
        $scope.warderobe = {}
        $scope.warderobe.rows = [
          [{name: 1, size: 80}, {name: 2, size: 80}],
          [{name: 3, size: 90}, {name: 4, size: 100}],
          [{name: 4, size: 60}, {name: 5, size: 80}]
        ]


        $scope.warderobeFieldColor = function(warderobeField, clothField)
        {
          //alert(warderobeField +"- "+clothField)
          if(warderobeField == clothField)
          {

            return "background-color: brown";
          }
        }

        $scope.startCam = function()
        {
          Instascan.Camera.getCameras().then(function (cameras) {
            console.log(cameras)
            if (cameras.length > 0) {
              console.log(cameras)
              //Back-facing Camera is getting selected
              myCam = cameras[0]
              /*if(cameras.length>1)
              {
                if(cameras[1].name.indexOf("back") != -1)
                {
                  scanner.start(cameras[1]);
                }
              }*/
scanner.start(myCam);
            } else {
              alert('No cameras found.');
            }
          }).catch(function (e) {
            console.error(e);
          });
        }

        $scope.open = function(worker)
        {
          if(worker.cssClasses == "active")
          {
            worker.cssClasses = "";
          }
          else {
            worker.cssClasses = "active";
          }

        }


        angular.element(document).ready(function () {
          window.scanner = new Instascan.Scanner({ video: document.getElementById('preview') });
          scanner = window.scanner
          scanner.addListener('scan', function (content) {
            $scope.qrFound(content);
          });
          Instascan.Camera.getCameras().then(function (cameras) {
            console.log(cameras)
            if (cameras.length > 0) {
              console.log(cameras)
              //Back-facing Camera is getting selected
              myCam = cameras[0]
              /*if(cameras.length>1)
              {
                if(cameras[1].name.indexOf("back") != -1)
                {
                  scanner.start(cameras[1]);
                }
              }*/
scanner.start(myCam);
            } else {
              alert('No cameras found.');
            }
          }).catch(function (e) {
            console.error(e);
          });
        })


        $scope.qrFound = function(data)
        {
          for (var key in $scope.mitarbeiter) {
            $scope.mitarbeiter[key].show = false;
          }
          if($scope.lastScan != data)
          {
            $scope.lastScan = data;
            window.navigator.vibrate([100])
            $("#signal").fadeIn()
            setTimeout(function(){
              $("#signal").fadeOut()
            },200)
            window.scanner.stop()
            $scope.nextButton = true;
            console.log(data)
            $timeout(function(){
              hash = data.split("s=")[1]
              email = $scope.hashes[hash]
              $scope.mitarbeiter[email].show = true;
              $scope.open($scope.mitarbeiter[email])
            })

            console.log($scope.mitarbeiter)
          }
          else {
            console.log("double")
          }
        }

        $scope.hash = function(email)
        {
          return md5(email);
        }
        $scope.borrowDonationBox = function(shift, worker)
        {
          NetworkService.borrowDonationBox(shift.Box, shift.SchichtId, shift.PositionId, worker.personalData.Email, function (data) {
            $scope.render()
          })
        }

        $scope.returnDonationBox = function(shift, worker, box)
        {
          NetworkService.returnDonationBox(box, shift.SchichtId, shift.PositionId, worker.personalData.Email, function (data) {
$scope.render()
          })
        }

        $scope.statusChanged = function(worker, shift)
        {

          NetworkService.presenceStatusChanged(shift.Done, shift.SchichtId, shift.PositionId, worker.personalData.Email, function (data) {

          })
        }

        $scope.render = function()
        {
          NetworkService.getMitarbeiterForEventDetailed(EventId, function (data) {
              $scope.mitarbeiter = data
              $scope.hashes = []
              for (var key in data) {
                $scope.hashes[md5(key)] = key
              }
          })
        }

        $scope.init = function ()
        {
          $scope.render()
        }

        $scope.init()
    }])
